// extracted by mini-css-extract-plugin
export var container = "KolabsStep-module--container--2mLd3";
export var infoContainer = "KolabsStep-module--infoContainer--3VLDX";
export var text = "KolabsStep-module--text--nId+G";
export var illustration = "KolabsStep-module--illustration--zgunL";